// extracted by mini-css-extract-plugin
export var brandLockup = "_fg-5";
export var brandLogo = "_fg-6";
export var bullet = "_fg-1i";
export var bulletText = "_fg-1h";
export var bullets = "_fg-1c";
export var callout = "_fg-12";
export var calloutBody = "_fg-14";
export var calloutLabel = "_fg-13";
export var checkIcon = "_fg-1e";
export var checkList = "_fg-1b";
export var checkSvg = "_fg-1f";
export var checkText = "_fg-1g";
export var choiceCard = "_fg-x";
export var choiceDescription = "_fg-10";
export var choiceIcon = "_fg-11";
export var choiceText = "_fg-y";
export var choiceTitle = "_fg-z";
export var closeButton = "_fg-d";
export var codeText = "_fg-28";
export var compactPage = "_fg-f";
export var content = "_fg-9";
export var contentColumn = "_fg-3";
export var coverageCard = "_fg-o";
export var coverageDescription = "_fg-24";
export var coverageTitle = "_fg-23";
export var eyebrow = "_fg-i";
export var fieldCard = "_fg-m";
export var fieldDescription = "_fg-r";
export var fieldError = "_fg-s";
export var fieldHeader = "_fg-p";
export var fieldTitle = "_fg-q";
export var finalNote = "_fg-29";
export var footer = "_fg-a";
export var fulfillmentBody = "_fg-1u";
export var fulfillmentBodyText = "_fg-1v";
export var fulfillmentRow = "_fg-1r";
export var fulfillmentRows = "_fg-1q";
export var fulfillmentTitle = "_fg-1t";
export var header = "_fg-4";
export var heading = "_fg-h";
export var helperText = "_fg-1k";
export var indented = "_fg-1x";
export var inlineLink = "_fg-26";
export var inlineTitle = "_fg-2a";
export var intro = "_fg-k";
export var linkPreview = "_fg-1z";
export var listItem = "_fg-1d";
export var main = "_fg-1";
export var marketingImage = "_fg-c";
export var marketingPanel = "_fg-b";
export var modal = "_fg-0";
export var noteBody = "_fg-v";
export var noteBodyText = "_fg-w";
export var noteCard = "_fg-n";
export var noteIcon = "_fg-t";
export var noteTitle = "_fg-u";
export var numberBadge = "_fg-2e";
export var numberedStep = "_fg-2c";
export var numberedStepBody = "_fg-2f";
export var numberedStepCta = "_fg-2d";
export var numberedStepDescription = "_fg-2h";
export var numberedStepTitle = "_fg-2g";
export var numberedSteps = "_fg-2b";
export var page = "_fg-e";
export var playCircle = "_fg-18";
export var playIcon = "_fg-19";
export var policyBody = "_fg-21";
export var policyHeader = "_fg-20";
export var policyPreview = "_fg-1y";
export var policyTitle = "_fg-22";
export var progressFill = "_fg-8";
export var progressTrack = "_fg-7";
export var pseudoLink = "_fg-25";
export var pseudoLinkIcon = "_fg-27";
export var rowHeader = "_fg-1s";
export var section = "_fg-g";
export var shell = "_fg-2";
export var statusIconSuccess = "_fg-1m";
export var statusIconSvg = "_fg-1o";
export var statusIconWarning = "_fg-1n";
export var statusRow = "_fg-1l";
export var statusText = "_fg-1p";
export var stepTitle = "_fg-j";
export var strongText = "_fg-1w";
export var subHeading = "_fg-l";
export var videoEmbed = "_fg-16";
export var videoIframe = "_fg-17";
export var videoLabel = "_fg-1a";
export var videoPlaceholder = "_fg-15";
export var warningIcon = "_fg-1j";